<mat-card appearance="outlined" class="php-card">
  <div class="header row">
    <div>
      <h2>PHP</h2>
    </div>
  </div>
  <div class="infos column">
    @if (php$ | async; as php) {
      <div class="info row">
        <span>Version</span>
        <b>{{ php.version }}</b>
      </div>
    }

    @for (config of configParameters$ | async; track $index) {
      <div class="info row" [class.column]="config.value.length > 7">
        <span>{{ config.name }}</span>
        <b>{{ config.value }}</b>
      </div>
    }

    @if (modules$ | async; as modules) {
      <div class="info column">
        <span>Enabled modules</span>
        <b>{{ modules }}</b>
      </div>
    }
  </div>

  <div class="buttons row">
    <button matButton="filled" (click)="openSettingsDialog()">
      <fa-icon [icon]="['fas', 'gear']" size="lg"></fa-icon>
      Settings
    </button>

    <button matButton="outlined">
      <fa-icon [icon]="['fas', 'terminal']" size="lg"></fa-icon>
      Generate PHP info()
    </button>
  </div>
</mat-card>
